import { useEffect } from 'react';
import useApi from './useApi';
import { useToast } from '../app/useToast';
import useApiEndpoints from '../context/useApiEndpoints';
import { useUserSettingsStore } from '../context/UserSettingsContext';
import { UserSettings } from '../types/ViewModel/UserSettings';
import { UserSettingsBM } from '../types/BusinessModel/UserSettingsBM';
import { buildQueryParams } from './endpoints/queryParamsHelper';
import apiEndpointUtils from 'src/utils/apiEndpointUtils';

export default () => {
    const { apiEndpoints } = useApiEndpoints();
    const { state, getApiData, postApiData } = useApi();
    const { setUserSettings, setUserSettingsLoaded } = useUserSettingsStore();
    const { processApiEndpointError } = apiEndpointUtils();

    const getUserSettings = () => {
        getApiData({
            endpoint: apiEndpoints['getUserSettings'].url,
        });
    };

    const upsertUserSettings = (newUserSettings: UserSettings) => {
        postApiData({
            endpoint: apiEndpoints['setUserSettings'].url,
            queryParam: buildQueryParams(newUserSettings),
            callInBackground: true,
        });
    };

    useEffect(() => {
        if (state.status !== 'success') {
            processApiEndpointError(state);
            return;
        }

        if (state.endpoint !== apiEndpoints['getUserSettings'].url) return;

        const userSettingsBM = state.result as unknown as UserSettingsBM;
        const userSettings = new UserSettings(
            userSettingsBM?.aolPeriod && userSettingsBM?.aolPeriod !== 'null' ? userSettingsBM?.aolPeriod : null,
            // if user setting for sort is null (not set by user), default to true.
            userSettingsBM?.sortAsc === null || userSettingsBM?.sortAsc
        );
        setUserSettings(userSettings);
        setUserSettingsLoaded(true);
    }, [state]);

    return { state, getUserSettings, upsertUserSettings };
};
